import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TTRowsOptions from './TTRowsOptions';
import { uploadFileTTRows } from 'redux/translationTable/TranslationTableActions';

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators({ uploadFileTTRows }, dispatch)
});

export default connect(null, mapDispatchToProps)(TTRowsOptions);



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowsOptions/TTRowsOptionsConnector.js